import API from "..";

export default class WorkRequestStatus {

  constructor({
    statusName,
    isActive,
    displayOrder
  }) 
    
  {
    this.statusName = statusName;
    this.isActive = isActive;
    this.displayOrder = displayOrder
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/workRequestStatus`);
    if (data.result) {
        return data.result
          .filter((d) => d.statusName !== 'Deleted')
          .map((d) => new WorkRequestStatus(d));
    }
    else {
        return [];
    }
  }
}
